import dayjs from "dayjs";
import { useGetLastWorkingDayQuery } from "./holidaysApi";

// "Yesterday" as the business means it: the last day anyone actually worked.
// Same rule and same server check as the phone app's
// core/holidays/yesterday_resolver.dart, so both clients agree on a Monday or
// after a public holiday.

const fmt = (d) => dayjs(d).format("YYYY-MM-DD");

export const calendarYesterday = () => dayjs().subtract(1, "day").format("YYYY-MM-DD");

// `date` itself when it was a working day, otherwise the last working day before
// it. Falls back to the plain calendar date if the check fails - exactly like the
// phone app - so a secondary lookup can never leave a screen with no dates at all.
// `isResolving` lets a caller hold its own queries until the answer is known,
// rather than fetching the Sunday first and the Saturday a moment later.
export const useWorkingDayOnOrBefore = (date, { skip = false } = {}) => {
  const active = !skip && Boolean(date);
  const { data, isError } = useGetLastWorkingDayQuery(date, { skip: !active });
  if (!active || isError || !data || data.isWorkingDay) {
    return { date, shifted: false, reason: null, isResolving: active && !data && !isError };
  }
  return { date: fmt(data.lastWorkingDay), shifted: true, reason: data.holidayReason || "a holiday", isResolving: false };
};

// Resolved yesterday plus the note every screen shows when it isn't calendar-yesterday -
// worded as the phone app words it: "Yesterday was Sunday — showing Sat 12 Sep instead."
export const useResolvedYesterday = ({ skip = false } = {}) => {
  const calendarDate = calendarYesterday();
  const r = useWorkingDayOnOrBefore(calendarDate, { skip });
  return {
    ...r,
    calendarDate,
    note: r.shifted ? `Yesterday was ${r.reason} — showing ${dayjs(r.date).format("ddd D MMM")} instead.` : null,
  };
};
